import type { App } from 'vue'
import { debounce } from './debounce'
import { permission } from './permission'

export function setupDirectives(app: App): void {
  app.directive('permission', permission)
  app.directive('debounce', debounce)
}

export { debounce, permission }
